import {isObject} from "@spoferan/spoferan-ts-core";

export default {

    emits: ['update:modelValue'],

    props: {
        // The value of the active item(s) to display
        modelValue: {
            default: null
        },
    },

    data() {
        return {
            activeItemValues: this.modelValue,

            toggleMultipleChildren: false,

            // The child items to toggle
            items: [],

            // The watchers to watch the child item's active state
            itemWatchers: []
        }
    },

    watch: {
        modelValue(value) {
            this.activeItemValues = value;
        },

        activeItemValues(activeItemValue, oldActiveItemValue) {
            this.$emit('update:modelValue', activeItemValue)

            let newValues = Array.isArray(activeItemValue) ? activeItemValue : [activeItemValue];

            if (oldActiveItemValue) {
                let oldValues = Array.isArray(oldActiveItemValue) ? oldActiveItemValue : [oldActiveItemValue];
                oldValues = oldValues.filter(x => !newValues.includes(x));

                if (oldValues && oldValues.length) {
                    oldValues.forEach(oldValue => {
                        this.deactivateItem(oldValue);
                    })
                }
            }

            if (newValues && newValues.length) {
                newValues.forEach(newValue => {
                    this.activateItem(newValue);
                })
            }
        }
    },

    methods: {
        register(item) {
            item._value = item.value === null ? this.items.length : item.value
            if ((Array.isArray(this.activeItemValues) && this.activeItemValues.indexOf(item._value) > -1) || item._value === this.activeItemValues) {
                this.activateItem(item)
            } else {
                this.deactivateItem(item)
            }
            this.items.push(item)
            this.itemWatchers.push(this.watchItem(item))
        },

        unregister(item) {
            const found = this.items.find(i => i._uid === item._uid)

            if (!found) return

            this.deactivateItem(found);

            const unwatch = this.itemWatchers.find(i => i._uid === found._uid)
            if (unwatch) {
                unwatch.isActive()
            }

            this.itemWatchers = this.itemWatchers.filter(i => i._uid !== found._uid)
            this.items = this.items.filter(i => i._uid !== found._uid)
        },

        watchItem(item) {
            const watcher = (item) => {
                return item.$watch('isActive', val => {
                    if (val) {
                        this.addActiveItem(item)
                    } else {
                        this.removeActiveItem(item)
                    }
                }, {immediate: true})
            }

            const watchers = {
                _uid: item._uid,
                isActive: () => {
                }
            }

            watchers.isActive = watcher(item)

            return watchers
        },

        // Used by tabs
        getItemIndexByValue(value) {
            return this.items.findIndex(item => {
                return item._value === value
            })
        },

        findItemByValue(value) {
            return this.items.find(item => {
                return item._value === value
            })
        },

        /**
         * Sets the active state of the given item.
         * Required to overwrite in components, e.g., Slider.
         *
         * @param item
         * @param active
         */
        setItemActiveState(item, active) {
            item.isActive = active;
        },

        addActiveItem(item) {
            if (!item) {
                return;
            }

            let itemValue = isObject(item) ? item._value : item;
            if (this.toggleMultipleChildren) {
                if (Array.isArray(this.activeItemValues)) {
                    if (this.activeItemValues.indexOf(itemValue) < 0) {
                        this.activeItemValues.push(itemValue)
                    }
                } else {
                    this.activeItemValues = this.activeItemValues && this.activeItemValues !== itemValue ? [this.activeItemValues, itemValue] : [itemValue]
                }
            } else {
                this.activeItemValues = itemValue
            }
        },

        removeActiveItem(item) {
            if (!item || !this.isActiveItem(item)) {
                return;
            }

            let itemValue = isObject(item) ? item._value : item;
            if (this.toggleMultipleChildren) {
                if (Array.isArray(this.activeItemValues) && this.activeItemValues.length) {
                    const index = this.activeItemValues.indexOf(itemValue);
                    if (index > -1) {
                        this.activeItemValues.splice(index, 1);
                    }
                } else {
                    this.activeItemValues = []
                }
            } else {
                this.activeItemValues = null
            }
        },

        isActiveItem(item) {
            let itemValue = isObject(item) ? item._value : item;
            return this.toggleMultipleChildren && Array.isArray(this.activeItemValues) ? this.activeItemValues.indexOf(itemValue) > -1 : this.activeItemValues === itemValue;
        },

        activateItem(item) {
            item = isObject(item) ? item : this.findItemByValue(item);
            if (item) {
                this.setItemActiveState(item, true)

                // We need to deactivate all other active items, if only one is allowed
                if (!this.toggleMultipleChildren) {
                    this.items.forEach(activeItem => {
                        if (activeItem._value !== item._value) {
                            this.deactivateItem(activeItem);
                        }
                    })
                }
            }
        },

        deactivateItem(item) {
            item = isObject(item) ? item : this.findItemByValue(item);
            if (item) {
                this.setItemActiveState(item, false)
            }
        }
    }
}
